import React from 'react';
import ReactDOM from 'react-dom';
import './public/utils';
import App from 'router';


/*热更新*/
if (module.hot) {
  module.hot.accept();
}

ReactDOM.render(<App />, document.getElementById("root"));

document.addEventListener("contextmenu", (e) => {
  e.preventDefault();
});